'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { hasMailerLiteEmbed, isMailerLiteLoaded, reinitMailerLite } from '@/utils/mailerlite';

/** Small delay so the new route's content (and any `.ml-embedded`) is mounted first. */
const REINIT_DELAY_MS = 150;

/**
 * Next.js client navigations don't reload the page, so MailerLite never re-scans the DOM:
 * popup "show on specific pages" rules don't re-evaluate and embedded forms added on the new
 * route stay empty. On each route change this tears MailerLite down and re-initialises it.
 *
 * Skips the first render (initial load already initialises via the loader snippet) and pages
 * where MailerLite isn't in use.
 */
const MailerLiteRouteReinit = () => {
  const _pathname = usePathname();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      if (!isMailerLiteLoaded() && !hasMailerLiteEmbed()) return;
      reinitMailerLite();
    }, REINIT_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  return null;
};

export default MailerLiteRouteReinit;
